import React from 'react';

const About = () => {
  return (
    <section id="about" className="section">
      <div className="container">
        <h2 className="section-title">About Me</h2>
        <div className="about-content">
          <div className="about-grid">
            <div className="about-image-section">
              <div className="about-image-container">
                <img 
                  src="/profile.jpg" 
                  alt="Ayham Netfaji" 
                  className="about-profile-image"
                />
              </div>
            </div>
            <div className="about-text-section">
              <p className="about-text">
                I'm pursuing a B.Tech in Information Science and Engineering at Jain University (2023–2027).
                I enjoy working on front-end development, responsive design, and digital marketing.
                Currently exploring full-stack development and improving my technical and creative problem-solving skills.
              </p>
              <p className="about-text">
                Born on June 5th, 2005, I bring a fresh perspective to the intersection of technology and marketing. 
                My passion lies in building scalable digital solutions while leveraging data-driven marketing strategies 
                to create meaningful impact in the digital space.
              </p>
              <div className="about-details">
                <h3 className="about-details-title">Quick Facts</h3>
                <ul className="about-facts">
                  <li><span className="fact-label">Location:</span> India</li>
                  <li><span className="fact-label">Age:</span> 20 years old</li>
                  <li><span className="fact-label">Phone:</span> +91 7019636394</li>
                  <li><span className="fact-label">Email:</span> ayham.apexonestudio@gmail.com</li>
                  <li><span className="fact-label">Focus:</span> Full Stack Development & Digital Marketing</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;